import React from "react";
import NotFoundSec from "../sections/pageNotFound/NotFoundSec";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";
import CustomImageComponent from "./CustomImageComponent";

const News = (props) => {
  const countryPrefix = useCountryPrefix();

  const { i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  const language = isArabic ? "/ar" : "";

  const { data } = props;
  return (
    <>

      {data?.sectionItems?.length > 0 ? (
        <section
          className="news-section"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="container">
            <h5 className="sub-title text-center">{data?.sectionTitle}</h5>
            <h2 className="title text-center">{data?.sectionHeader}</h2>
            <div className="row">
              {data?.sectionItems?.length &&
                data.sectionItems.map((item, index) => (
                  <div className="col-md-6 col-lg-4 mb-4 mb-lg-0" key={index}>
                    <div className="flex-card">
                      <div className="img-block">
                        <a href={`/${countryPrefix}${language ? `/${language}` : ""}/blogs/${item.slug}`}>
                          <CustomImageComponent
                            src={item.image}
                            alt={item.title}
                            className={"img-fluid news-img"}
                          />
                        </a>
                        {/* <span className="date-text">{item.publishedDate}</span> */}
                        <span className="date-text">
                          {new Date(item.publishedDate).toLocaleString("default", {
                            month: "long",
                          }) +
                            " " +
                            new Date(item.publishedDate).getDate() +
                            ", " +
                            new Date(item.publishedDate).getFullYear()}
                        </span>
                      </div>
                      <div className="content-block">
                        <ul className="category-list">
                          <li className="active">
                            <span>
                              <CustomImageComponent
                                src={"/assets/img/admin-icon.svg"}
                                alt={"comments-icon"}
                                className={"img-fluid"}
                              />
                              {item.author}
                            </span>
                          </li>
                        </ul>
                        <h3>
                          <a href={`/${countryPrefix}${language ? `/${language}` : ""}/blogs/${item.slug}`} className="link">
                            <span className="underline">{item.title}</span>
                          </a>
                        </h3>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>
      ) :
        (
          <section
            className=""
            data-aos="fade-up"
            data-aos-duration="1500"
          ></section>
        )}


    </>
  );
};

export default News;
